// extracted by mini-css-extract-plugin
export var errorsContainer = "_vn-1";
export var link = "_vn-0";